import { useField } from "formik";

import { IDNumberInput, IDNumberProps } from "./IDNumberInput";

export function IdNumberInputField(props: IDNumberProps) {
  const { name, onChange, country, label, ...IdNumberInputProps } = props;
  const [field, meta, helpers] = useField(props.name);

  return (
    <IDNumberInput
      {...IdNumberInputProps}
      name={field.name}
      validationState={meta.touched && meta.error ? "invalid" : "valid"}
      errorMessage={meta.touched && meta.error}
      value={field.value}
      onChange={helpers.setValue}
      isRequired={props.isRequired}
      country={props.country}
      onBlur={field.onBlur}
    />
  );
}
